import React, { useEffect, useState } from "react";
import { Col, Placeholder, Row } from "react-bootstrap";

import translate from "../../../../services/Translate";
import { fetchUserAdvancements } from "./UserDiplomation.function";

const UserDiplomation = ({ language, userId }: { language: string; userId: number }) => {
  const [advancements, setAdvancements] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUserAdvancements(userId, setAdvancements, setLoading);
  }, [userId]);

  if (loading) {
    return (
      <div className="w-100">
        <h2>
          <Placeholder as="span" animation="glow" className="w-50">
            <Placeholder xs={5} />
          </Placeholder>
        </h2>

        {[...Array(2)].map((_, index) => (
          <Row key={`mock-cohort-${index}`} className="w-100 mb-3 s-regular border-bottom">
            <Col lg className="my-3">
              <Placeholder as="h3" animation="glow">
                <Placeholder xs={6} />
              </Placeholder>

              <div className="mb-2 row justify-content-between">
                <Placeholder as="div" animation="glow" className="d-flex justify-content-between mb-2">
                  <Placeholder xs={5} />
                  <Placeholder xs={2} />
                </Placeholder>
              </div>

              <Placeholder as="div" animation="glow" className="mb-2">
                <Placeholder xs={2} />
              </Placeholder>

              {[...Array(2)].map((_, index) => (
                <div key={`mock-projet-${index}`} className="d-flex justify-content-between">
                  <Placeholder animation="glow" className="w-50 me-2">
                    <Placeholder xs={8} />
                  </Placeholder>
                  <Placeholder animation="glow" className="w-25 text-end">
                    <Placeholder xs={6} />
                  </Placeholder>
                </div>
              ))}
            </Col>
            <Col>{/* Future content placeholder */}</Col>
          </Row>
        ))}
      </div>
    );
  }
  return (
    <div className="w-100">
      <h2>{translate(language, "PAGES.USER.DIPLOMATION.TITLE")}</h2>
      {advancements.length > 0 ? (
        advancements.map((cohort: any) => (
          <Row key={`cohort-${cohort.cohort_id}`} className="w-100 mb-3 s-regular border-bottom">
            <Col lg className="my-3">
              <h3 className="fw-bold mb-3">{cohort.cohort_name}</h3>
              <div className="mb-2 d-flex justify-content-between">
                <div className="me-2">
                  <strong>{translate(language, "PAGES.USER.DIPLOMATION.MANDATORY_EXAMS")}</strong>
                </div>
                <div>
                  {cohort.total_mandatory_exams_success}/{cohort.total_mandatory_exams_total}
                </div>
              </div>

              <h4 className="s-regular mb-1 fw-bold">{translate(language, "PAGES.USER.DIPLOMATION.PROJECTS")}</h4>
              {cohort.projects.length > 0 ? (
                cohort.projects.map((project: any) => {
                  const gradeScore = project.grade_score;

                  const [scoreValue, baseValue] = (gradeScore ?? "").split("/").map(Number);
                  const isConformGradeScore = !isNaN(scoreValue) && !isNaN(baseValue);

                  return (
                    <div key={`project-${project.id}`} className="d-flex justify-content-between">
                      <div className="me-2">
                        {project.name}
                        {cohort.need_project === false && (
                          <span className="ms-2">({translate(language, "PAGES.USER.DIPLOMATION.OPTIONAL")})</span>
                        )}
                      </div>
                      <div className="d-flex text-nowrap align-items-center">
                        {isConformGradeScore ? (
                          <React.Fragment>
                            {gradeScore}
                            <span
                              className={`dst-icon-${
                                isConformGradeScore && scoreValue >= baseValue / 2
                                  ? "check-circle text-success"
                                  : "x-circle text-danger"
                              } ms-2`}
                            />
                          </React.Fragment>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="me-3">N/A</div>
              )}
            </Col>
            <Col>{/* Future content placeholder */}</Col>
          </Row>
        ))
      ) : (
        <p>{translate(language, "PAGES.USER.DIPLOMATION.NO_PROGRESS_DATA")}</p>
      )}
    </div>
  );
};

export default UserDiplomation;
